import './styles.scss'

import React, { useEffect, useState } from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import Content from './content'

import courseLogic from '~/scenes/course/show/logic'

const Booking = ({ otherCoursesExist }) => {
  const { isDesktopWithInBetween } = useValues(courseLogic)

  const [isDesktopWithInBetweenBreakpoint, setIsDesktopWithInBetweenBreakpoint] = useState(false)

  useEffect(() => {
    setIsDesktopWithInBetweenBreakpoint(isDesktopWithInBetween)
  }, [isDesktopWithInBetween])

  return (
    <div className={`booking-container white${!otherCoursesExist && isDesktopWithInBetweenBreakpoint ? ' last' : ''}`}>
      <div className='booking-title'>{I18n.t('courses.show.availability')}</div>
      <div className='booking-content'>
        <Content />
      </div>
    </div>
  )
}

Booking.propTypes = {
  otherCoursesExist: PropTypes.bool
}

export default Booking
